import {
  Box,
  Button,
  Container,
  Heading,
  List,
  ListIcon,
  ListItem,
  Text,
  VStack,
} from '@chakra-ui/react'
import { Link as RouterLink } from 'react-router-dom'
import { FiCheckCircle } from 'react-icons/fi'

export const BrigadesPage: React.FC = () => {
  return (
    <Container maxW="container.xl" py={8}>
      <VStack align="stretch" spacing={6}>
        <Box>
          <Heading as="h1" size="2xl" color="brand.500" mb={3}>
            👷 Бригады
          </Heading>
          <Text color="gray.600" fontSize="lg">
            Бригады — это исполнители в графике. Чем аккуратнее они настроены,
            тем проще планировать и анализировать загрузку.
          </Text>
        </Box>

        <Box>
          <Heading size="md" mb={3}>Базовые правила</Heading>
          <List spacing={2}>
            <ListItem><ListIcon as={FiCheckCircle} color="green.500" />Используйте понятные названия бригад (без сокращений «для своих»).</ListItem>
            <ListItem><ListIcon as={FiCheckCircle} color="green.500" />Один тип работ — одна логичная бригада (не смешивайте разные направления).</ListItem>
            <ListItem><ListIcon as={FiCheckCircle} color="green.500" />Перед планированием проверяйте, что нужная бригада есть в списке.</ListItem>
          </List>
        </Box>

        <Box>
          <Heading size="md" mb={3}>Где это влияет</Heading>
          <List spacing={2}>
            <ListItem><ListIcon as={FiCheckCircle} color="green.500" />Назначение задач в «Графике работ».</ListItem>
            <ListItem><ListIcon as={FiCheckCircle} color="green.500" />Фильтрация и выгрузка отчётов за период.</ListItem>
          </List>
        </Box>

        <Box>
          <Button as={RouterLink} to="/schedule" mr={3} variant="outline">К графику</Button>
          <Button as={RouterLink} to="/settings" variant="outline">К настройкам и отчётам</Button>
        </Box>
      </VStack>
    </Container>
  )
}
